export const renderContextChecksItem = (contextChecks) => {
    const hasUncited = contextChecks.uncitedReferences && contextChecks.uncitedReferences.length > 0;
    const hasOutOfContext = contextChecks.outOfContextReferences && contextChecks.outOfContextReferences.length > 0;

    const renderUncitedReferences = () => {
        if (!hasUncited) {
            return null;
        }

        return (
            <div className="border rounded p-3">
                <div className="mb-2">
                    <span className="fw-bold text-dark">Unused references:</span> {contextChecks.uncitedReferences.length}
                </div>
                <ol className="mb-0">
                    {contextChecks.uncitedReferences.map((item, index) => (
                        <li
                            key={`${item.referenceNumber}-${index}`}
                            value={item.referenceNumber}
                            className={index === contextChecks.uncitedReferences.length - 1 ? "" : "mb-2"}
                        >
                            {item.reference}
                        </li>
                    ))}
                </ol>
            </div>
        );
    };

    const renderOutOfContextReferences = () => {
        if (!hasOutOfContext) {
            return null;
        }

        return (
            <div className="border rounded p-3">
                <div className="mb-2">
                    <span className="fw-bold text-dark">Out-of-context references:</span> {contextChecks.outOfContextReferences.length}
                </div>
                <ol className="mb-0">
                    {contextChecks.outOfContextReferences.map((item, index) => (
                        <li
                            key={`${item.referenceNumber}-${index}`}
                            value={item.referenceNumber}
                            className={index === contextChecks.outOfContextReferences.length - 1 ? "" : "mb-3"}
                        >
                            <div>{item.reference}</div>
                            {item.reason && <div className="text-muted small mt-1">{item.reason}</div>}
                        </li>
                    ))}
                </ol>
            </div>
        );
    };

    return (
        <>
            {renderUncitedReferences()}
            {hasUncited && hasOutOfContext && <div className="mt-3" />}
            {renderOutOfContextReferences()}
        </>
    );
};